import React from "react";
import HeroSlider from '../../layouts/hero-slider';
import Section1 from '../../layouts/sections/section-1';
import Section2 from '../../layouts/sections/section-2';
import Section3 from '../../layouts/sections/section-3';
import Section4 from '../../layouts/sections/section-4';
import Section5 from '../../layouts/sections/section-5';
import Section6 from '../../layouts/sections/section-6';
import Pricing from "../../components/pricing";
import Contact from "../../components/contact";


const Main = () => {
  return (
    <div id="main">
      <HeroSlider />
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Pricing />
      <Contact />
    </div>
  );
};

export default Main;